import type { RunnerTimesnap } from '@rundown-studio/types'

export interface Moment extends RunnerTimesnap {
  total: number
  left: number
  countdown: number
  countup: number
  ended: boolean
}

export function createMoment(
  timesnap: RunnerTimesnap | null = null,
  now?: number,
): Moment {
  const tenMin = 60000
  if (!now || now <= 0) now = Date.now()
  const ts = _timesnapDefaults(timesnap)

  // Calculate 'total' (round 10 ms due to inaccuracies)
  const total = ts.deadline ? ts.deadline - ts.kickoff : tenMin

  // Calculate 'left'
  let left: number
  if (ts.cueId === null)
    left = 0 // Runner has ended
  else if (!ts.deadline) left = 0
  else if (ts.running) left = ts.deadline - now
  else left = ts.deadline - ts.lastStop

  // Correct edge-case where left > total
  if (left > total) left = total

  // Calculate 'time'
  const stop = false

  return {
    ...ts,
    total: floor50(total),
    left: floor50(left),
    countdown: floor50(stop ? 0 : left),
    countup: floor50(stop ? total : total - left),
    ended: ts.cueId === null,
  }
}

export function floor50(num: number): number {
  return Math.floor(num / 50) * 50
}

function _timesnapDefaults(timesnap: RunnerTimesnap | null): RunnerTimesnap {
  return {
    cueId: null,
    running: false,
    kickoff: 0,
    lastStop: 0,
    deadline: 0,
    ...timesnap,
  }
}
